import {
  JsonAPIErrorMessage,
  JsonAPIErrorResponse,
} from './interfaces/JSONApi.js'

export class JSONApiError extends Error {
  public errors: JsonAPIErrorMessage[]
  constructor(error: JsonAPIErrorResponse) {
    super(error.errors[0].message)
    this.errors = error.errors
  }
}
